type UserStoredFiltersInput = {
  interactionFilters?: unknown;
  serviceFilters?: unknown;
  engagementFilters?: unknown;
};

type NonPIUserSettingsInput = {
  isEmailNotificationOn?: unknown;
  userStoredFilters?: unknown;
};

type UserMetaNonPIRequestInput = {
  nonPIUserSettings?: unknown;
};

const normalizeUserStoredFilters = (value: unknown) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }
  const input = value as UserStoredFiltersInput;
  const output: { interactionFilters?: string; serviceFilters?: string; engagementFilters?: string } = {};
  if (typeof input.interactionFilters === 'string') {
    output.interactionFilters = input.interactionFilters;
  }
  if (typeof input.serviceFilters === 'string') {
    output.serviceFilters = input.serviceFilters;
  }
  if (typeof input.engagementFilters === 'string') {
    output.engagementFilters = input.engagementFilters;
  }
  return output;
};

const normalizeNonPIUserSettings = (value: unknown) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }
  const input = value as NonPIUserSettingsInput;
  const output: { isEmailNotificationOn?: boolean; userStoredFilters?: ReturnType<typeof normalizeUserStoredFilters> } =
    {};
  if (typeof input.isEmailNotificationOn === 'boolean') {
    output.isEmailNotificationOn = input.isEmailNotificationOn;
  }
  if (input.userStoredFilters !== undefined) {
    const normalizedFilters = normalizeUserStoredFilters(input.userStoredFilters);
    if (Object.keys(normalizedFilters).length > 0) {
      output.userStoredFilters = normalizedFilters;
    }
  }
  return output;
};

export const normalizeUserMetaNonPIRequestBody = (value: UserMetaNonPIRequestInput) => {
  const input: UserMetaNonPIRequestInput =
    value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  return {
    nonPIUserSettings: normalizeNonPIUserSettings(input.nonPIUserSettings),
  };
};
